export enum RequestTypeEnum {
  GET,
  POST,
  PUT,
  PATCH,
  DELETE,
  GET_TEXT,
  GET_PAGE,
  GET_IMAGE,
  GET_IMAGE_BY_POST_REQUEST,
}
